var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40.376c11.046 0 20-8.954 20-20 0-11.045-8.954-20-20-20s-20 8.955-20 20c0 11.046 8.954 20 20 20ZM10 26.907c9.145 5.8 20.466.44 19.477-11.046a5.157 5.157 0 0 0 1.628-3.999 9.004 9.004 0 0 1-2.833 1.066c-3.37-3.338-8.63-.403-7.584 3.988-3.528-.172-6.912-1.719-9.181-4.575-1.161 1.99-.537 4.59 1.38 5.843a4.457 4.457 0 0 1-2.019-.543v.053c-.07 2.064 1.631 3.907 3.58 4.287a4.652 4.652 0 0 1-2.018.085c.589 1.784 2.303 2.994 4.156 3.028-1.574 1.318-4.263 2.094-6.586 1.813Z"
  })));
};
export default SvgTwitter;